import { BrowserRouter as Router } from 'react-router-dom'
import { Suspense } from 'react'
import { Provider } from 'react-redux'
import { AuthProvider } from '@praxis/component-auth'
import { Spinner } from '@enterprise-ui/canvas-ui-react'
import { HelveticaForTarget } from '@enterprise-ui/component-font'
import { ApolloProvider } from '@apollo/client'
import { client } from './servicesGraphQl'
import { findAppPath } from './resources/searchUtills'
import { Main } from './views/main/'
import { AnalyticsProvider } from '@praxis/analytics/client'
import veItemBulkMfeConfig from './config/'
import store from './store/'
import '@enterprise-ui/canvas-ui-css'
import '@enterprise-ui/canvas-ui-css-autocomplete'

const App = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <HelveticaForTarget variants={['n4', 'n5', 'n7']} />
      <Router basename={findAppPath()}>
        <AuthProvider {...veItemBulkMfeConfig.auth}>
          <ApolloProvider client={client}>
            <Provider store={store}>
              <AnalyticsProvider
                trackClicks
                config={veItemBulkMfeConfig.analytics}
              >
                <Main />
              </AnalyticsProvider>
            </Provider>
          </ApolloProvider>
        </AuthProvider>
      </Router>
    </Suspense>
  )
}

export default App
